import types from '../actionTypes';

const initialState = null;

export default (state = initialState, action) => {
    switch (action.type) {
        case types.SET_NEW_PIN: {
            return action.payload;
        }
        case types.REMOVE_NEW_PIN: {
            return initialState;
        }
        default:
            return state;
    }
};
